module.exports = __webpack_public_path__ + "media/slv/bghead-2d380f6e.png";